import React, { Component } from 'react';

class Ticker extends Component {
  componentDidMount(){
    if(document.getElementById('tickertape')){
      let newDoc = document.createElement('div')
      newDoc.innerHTML = document.getElementById('tickertape').innerHTML
      document.getElementById("ticker-container").appendChild(newDoc);
      newDoc.style.display = 'block';
    }
  }
  render() {
    let style = {height:'40px',background:'rgb(10,10,10)'
      // ,paddingTop:'43px',marginBottom:'44px'
    }
    return (
      <div id='ticker-container' className='minWidth' style={style}>
      </div>
    );
  }
}

export default Ticker;
